module.exports = __webpack_public_path__ + "static/media/logo.1d7a6919.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo.jpg
// module id = 779
// module chunks = 2